import create from 'zustand';

import Trade from '../components/widgets/Trade';
import Orders from '../components/widgets/Orders';
import Console from '../components/widgets/Console';
import Profile from '../components/widgets/Profile';
import Settings from '../components/widgets/Settings';
import Exchanges from "../components/widgets/Exchanges";
import Candles from "../components/widgets/Candles";
import Orderbook from "../components/widgets/Orderbook";
import UserSettings from '../components/widgets/UserSettings';
import Portfolio from '../components/widgets/Portfolio';
import Positions from '../components/widgets/Positions';


const allWidgets = {
  console: { w: 5, h: 4, x: 4, y: 6, component: Console },
  settings: { w: 3, h: 6, x: 0, y: 0, component: Settings },
  exchanges: { w: 3, h: 3, x: 0, y: 0, component: Exchanges },
  targets: { w: 3, h: 3, x: 0, y: 0, component: UserSettings },
  trade: { w: 4, h: 8, x: 0, y: 0, component: Trade },
  open_orders: { w: 5, h: 6, x: 4, y: 0, component: Orders },
  portfolio: { w: 4, h: 4, x: 0, y: 0, component: Portfolio },
  candles: { w: 4, h: 4, x: 0, y: 0, component: Candles },
  positions: { w: 4, h: 4, x: 0, y: 0, component: Positions },
};
const multiInstanceWidgets = {
  candles: true,
  orderbook: true,
  portfolio: true,
};

//MONITOR
const widgetDefaults = {
  console: { w: 5, h: 5, x: 3, y: 6, component: Console },
  // settings: { w: 3, h: 5, x: 9, y: 0, component: Settings },
  // exchanges: { w: 3, h: 3, x: 0, y: 8, component: Exchanges },
  // targets: { w: 3, h: 3, x: 9, y: 5, component: UserSettings },
  trade: { w: 3, h: 8, x: 0, y: 0, component: Trade },
  open_orders: { w: 5, h: 6, x: 3, y: 0, component: Orders },
  positions: { w: 4, h: 6, x: 8, y: 0, component: Positions }
};

const initialWidgetList = [
  { i:"console", component: Console },
 { i:"settings", component: Settings },
  {i:"exchanges", component: Exchanges },
  { i:"targets", component: UserSettings },
  { i:"trade", component: Trade },
  { i:"open_orders", component: Orders },
  { i:"positions", component: Positions },
  // { i:"portfolio", component: Portfolio },
  // { i:"candles", component: Candles },
]
// const initialWidgetList = Object.keys(widgetDefaults).map(key => ({ i: key, component: widgetDefaults[key].component }));

const defaultLayouts = Object.keys(widgetDefaults).map(key => ({
  i: key,
  x: widgetDefaults[key].x,
  y: widgetDefaults[key].y,
  w: widgetDefaults[key].w,
  h: widgetDefaults[key].h,
  component: widgetDefaults[key].component
}));
// TABLET
const TabletDefault = {
  console: { w: 5, h: 3, x: 4, y: 6, component: Console },
  trade: { w: 4, h: 7, x: 0, y: 0, component: Trade },
  open_orders: { w: 5, h: 5, x: 4, y: 0, component: Orders },
}
const initialTabletWidgetList = initialWidgetList
const defaultTabletLayouts = Object.keys(TabletDefault).map(key => ({
  i: key,
  x: TabletDefault[key].x,
  y: TabletDefault[key].y,
  w: TabletDefault[key].w,
  h: TabletDefault[key].h,
  component: TabletDefault[key].component
}));
//PORTRAIT
const TabletPortraitDefault = {
  console: { w: 5, h: 3, x: 0, y: 10, component: Console },
  trade: { w: 3, h: 6, x: 0, y: 0, component: Trade },
  open_orders: { w: 5, h: 4, x: 0, y: 6, component: Orders },
}
const initialTabletPortraitWidgetList = initialWidgetList
const defaultTabletPortraitLayouts = Object.keys(TabletPortraitDefault).map(key => ({
  i: key,
  x: TabletPortraitDefault[key].x,
  y: TabletPortraitDefault[key].y,
  w: TabletPortraitDefault[key].w,
  h: TabletPortraitDefault[key].h,
  component: TabletPortraitDefault[key].component
}));
const rehydrateComponents = (layouts) => {
  return layouts.map(layout => ({
    ...layout,
    component: allWidgets[layout.i.split('-')[0]]?.component || null
  }));
};

// GRID STORE
const useGridStore = create((set, get) => ({
  tabs: [
    { id: 1, name: 'Main', layouts: defaultLayouts, listItems: initialWidgetList.filter(item => !defaultLayouts.map(layout => layout.i).includes(item.i)) },
  ],
  activeTabId: 1,
  defaultLayouts, 
  savedLayouts: JSON.parse(localStorage.getItem('savedLayouts')) || [], 
  setActiveTab: (tabId) => set({ activeTabId: tabId }),
  renameTab: (tabId, newName) => set((state) => ({
    tabs: state.tabs.map(tab => tab.id === tabId ? { ...tab, name: newName } : tab)
  })),
  addTab: (name) => set((state) => {
    const newTabId = Date.now();
    return {
      tabs: [...state.tabs, { id: newTabId, name, layouts: [], listItems: initialWidgetList }],
      activeTabId: newTabId,
    };
  }),

  removeTab: (tabId) => set((state) => {
    console.log('Tabs', state.tabs)
    const remainingTabs = state.tabs.filter(tab => tab.id !== tabId);
    console.log('Remove', remainingTabs, "active id", remainingTabs.length ? remainingTabs[0].id : null)
    return {
      tabs: remainingTabs,
      activeTabId: remainingTabs.length ? remainingTabs[0].id : null,
    };
  }),
  setLayouts: (layouts) => set((state) => ({
    tabs: state.tabs.map(tab => tab.id === state.activeTabId ? { ...tab, layouts } : tab)
  })),
  setListItems: (newListItems) => set((state) => ({
    tabs: state.tabs.map(tab => tab.id === state.activeTabId ? { ...tab, listItems: newListItems } : tab)
  })),
  onLayoutChange: (currentLayout) => set((state) => ({
    tabs: state.tabs.map(tab => tab.id === state.activeTabId ? {
      ...tab,
      layouts: currentLayout ? currentLayout.map(layout => ({
        ...layout,
        component: tab.layouts.find(item => item.i === layout.i)?.component
      })) : []
    } : tab)
  })),
  addToGrid: (item) => set((state) => {
    const tab = state.tabs.find(tab => tab.id === state.activeTabId);
    const isMultiInstance = multiInstanceWidgets[item.i] || false;
    const newItem = isMultiInstance
      ? { ...item, i: `${item.i}-${Date.now()}` } 
      : item;

    const layoutDefaults = allWidgets[item.i] || { w: 4, h: 4, x: 0, y: 0 };

    return {
      tabs: state.tabs.map(tab => tab.id === state.activeTabId ? {
        ...tab,
        layouts: [...tab.layouts, { i: newItem.i, x: layoutDefaults.x, y: layoutDefaults.y, w: layoutDefaults.w, h: layoutDefaults.h, component: newItem.component }],
        listItems: isMultiInstance ? tab.listItems : tab.listItems.filter(i => i.i !== item.i)
      } : tab)
    };
  }),
  removeFromGrid: (item) => set((state) => {
    const isMultiInstance = item.i.split('-')[0] in multiInstanceWidgets;
    return {
      tabs: state.tabs.map(tab => tab.id === state.activeTabId ? {
        ...tab,
        layouts: tab.layouts.filter(i => i.i !== item.i),
        listItems: isMultiInstance ? tab.listItems : [...tab.listItems, { i: item.i.split('-')[0], component: item.component }]
      } : tab)
    };
  }),
  loadLayout: (layoutName) => set((state) => {
    const { savedLayouts } = get();
    const layout = savedLayouts.find(layout => layout.name === layoutName);
    if (layout) {
      // Add UIDs back when loading
      const rehydratedLayouts = layout.layouts.map((layout) => {
        const baseId = layout.i.split('-')[0];
        const isMultiInstance = multiInstanceWidgets[baseId] || false;
        const uid = isMultiInstance ? `-${Date.now()}` : '';
        
        return { ...layout, i: baseId + uid };
      });
      
      // Rehydrate components
      const layoutsWithComponents = rehydrateComponents(rehydratedLayouts);
      const displayedWidgets = layoutsWithComponents.map(layout => layout.i.split('-')[0]);
      const newWidgetList = initialWidgetList.filter(item => !displayedWidgets.includes(item.i) || multiInstanceWidgets[item.i]);
      return {
        tabs: state.tabs.map(tab => tab.id === state.activeTabId ? { ...tab, layouts: layoutsWithComponents, listItems: newWidgetList } : tab)
      };
    } else {
      const { defaultLayouts } = get();
    const displayedWidgets = defaultLayouts.map(layout => layout.i.split('-')[0]);
    const newWidgetList = initialWidgetList.filter(item => !displayedWidgets.includes(item.i));
    return {
      tabs: state.tabs.map(tab => tab.id === state.activeTabId ? { ...tab, layouts: defaultLayouts, listItems: newWidgetList } : tab),
    };
    }
  }),
  resetToDefaultLayout: () => set((state) => {
    const { defaultLayouts } = get();
    const displayedWidgets = defaultLayouts.map(layout => layout.i.split('-')[0]);
    const newWidgetList = initialWidgetList.filter(item => !displayedWidgets.includes(item.i));
    return {
      tabs: state.tabs.map(tab => tab.id === state.activeTabId ? { ...tab, layouts: defaultLayouts, listItems: newWidgetList } : tab),
    };
  }),
  resetTabletDefault: () => set((state) => {
    const displayedWidgets = defaultTabletLayouts.map(layout => layout.i.split('-')[0]);
    const newWidgetList = initialTabletWidgetList.filter(item => !displayedWidgets.includes(item.i));
    return {
      tabs: state.tabs.map(tab => tab.id === state.activeTabId ? { ...tab, layouts: defaultTabletLayouts, listItems: newWidgetList } : tab)
    };
  }),
  resetTabletPortraitDefault: () => set((state) => {
    const displayedWidgets = defaultTabletPortraitLayouts.map(layout => layout.i.split('-')[0]);
    const newWidgetList = initialTabletPortraitWidgetList.filter(item => !displayedWidgets.includes(item.i));
    return {
      tabs: state.tabs.map(tab => tab.id === state.activeTabId ? { ...tab, layouts: defaultTabletPortraitLayouts, listItems: newWidgetList } : tab)
    };
  }),
  saveLayout: (layoutName) => set((state) => {
    const { savedLayouts, tabs, activeTabId } = get();
    const activeTab = tabs.find(tab => tab.id === activeTabId);
    if (activeTab) {
      // Remove UIDs before saving
      const sanitizedLayouts = activeTab.layouts.map(layout => {
        const baseId = layout.i.split('-')[0];
        return { ...layout, i: baseId };
      });
  
      const newSavedLayouts = [
        ...savedLayouts.filter(layout => layout.name !== layoutName),
        { name: layoutName, layouts: sanitizedLayouts }
      ];
      localStorage.setItem('savedLayouts', JSON.stringify(newSavedLayouts));
      return { savedLayouts: newSavedLayouts };
    }
  }),

 
  deleteLayout: (layoutName) => set((state) => {
    const newSavedLayouts = get().savedLayouts.filter(layout => layout.name !== layoutName);
    localStorage.setItem('savedLayouts', JSON.stringify(newSavedLayouts));
    return { savedLayouts: newSavedLayouts };
  })
}));

export default useGridStore;
